// ##############################
// // // Button Group styles
// #############################

const buttonGroupStyle = {
  buttonGroup: {
    '@media (max-width: 767px)': {
      margin: '16px 0 32px',
      display: 'flex'
    }
  },
  buttons: {
    margin: '0 4px',
    '&:hover': {
      // backgroundColor: '#eee',
      zIndex: '2'
    }
  }
};

export default buttonGroupStyle;
